'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dRealm from "./presto.types$-Site-Realm.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteRealm$$anon$117(_$ordinal$32, \u03b4name$32, outer) {
  this.cyj = 0;
  this.a9R = null;
  this.cyj = _$ordinal$32;
  this.a9R = \u03b4name$32;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SiteRealm$$anon$117 as $c_Lpresto_types$SiteRealm$$anon$117 };
$p = $c_Lpresto_types$SiteRealm$$anon$117.prototype = new $j_presto$002etypes$0024$002dSite$002dRealm.$h_Lpresto_types$SiteRealm();
$p.constructor = $c_Lpresto_types$SiteRealm$$anon$117;
/** @constructor */
function $h_Lpresto_types$SiteRealm$$anon$117() {
}
export { $h_Lpresto_types$SiteRealm$$anon$117 as $h_Lpresto_types$SiteRealm$$anon$117 };
$h_Lpresto_types$SiteRealm$$anon$117.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9R;
});
$p.l = (function() {
  return this.a9R;
});
var $d_Lpresto_types$SiteRealm$$anon$117 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteRealm$$anon$117, "presto.types$SiteRealm$$anon$117", ({
  a1T: 1,
  a1R: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$SiteRealm$$anon$117 as $d_Lpresto_types$SiteRealm$$anon$117 };
//# sourceMappingURL=presto.types$-Site-Realm$$anon$117.js.map
